import React from "react";

const Footer = () => {
  return (
    <footer
      className="footer"
      style={{ backgroundColor: "black", marginBottom: 0 }}
    >
      <p className="text-light text-center p-3">
        <i className="fa fa-shopping-cart me-2" aria-hidden="true"></i>
        @Shopping-Cart 2021
      </p>
    </footer>
  );
};

export default Footer;
